module.exports = __webpack_public_path__ + "img/screen_4.f3ec1844.png";